import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-breadcrumb-stepper",
    templateUrl: "./breadcrumb-stepper.component.html",
    styleUrls: ["./breadcrumb-stepper.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BreadcrumbStepperComponent {
  @Input() steps: {
    label: string;
    state: "not-visited" | "current" | "completed" | "failed";
    iconKey: string;
  }[] = [];

  getIconClass(iconKey: string, state: string): string {
    if (state === "completed") return "fa fa-check white-icon";
    if (state === "failed") return "fa fa-times white-icon";
    if (state === "current") return `fa fa-${iconKey} white-icon`;
    return `fa fa-${iconKey} grey-icon`;
  }

  isLineActive(index: number): boolean {
    // If next step is completed or current, then the line is green
    const nextStep = this.steps[index + 1];
    return (
      nextStep &&
      (nextStep.state === "completed" || nextStep.state === "current")
    );
  }
}
